// extracted by mini-css-extract-plugin
module.exports = {"Helping":"TextGroupSectionC_Helping__29cFb","TextContainer":"TextGroupSectionC_TextContainer__112Q2"};